<template>
  <NewStudioModalsModalShell class="room-modal" title="View in Your Room" size="compact" data-figma-node="2909:175846" @close="$emit('close')">
    <ClientOnly>
      <model-viewer v-if="modelUrl" class="ar-launcher" :src="modelUrl" ar ar-modes="webxr scene-viewer quick-look" />
    </ClientOnly>
    <div v-if="loading" class="room-state"><i class="fal fa-spinner fa-spin" /><p>Preparing your 3D model…</p></div>
    <div v-else-if="error" class="room-state"><p role="alert">{{ error }}</p><button type="button" @click="$emit('retry')">Try Again</button></div>
    <template v-else-if="arPageUrl">
      <div class="qr" :data-qr-value="arPageUrl"><QRCodeVue :value="arPageUrl" :size="300" level="M" :margin="2" /></div>
      <h3><svg class="phone-icon" width="12" height="20" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6 1H3.4C2.07452 1 1 1.89543 1 3V19C1 20.1046 2.07452 21 3.4 21H10.6C11.9255 21 13 20.1046 13 19V3C13 1.89543 11.9255 1 10.6 1Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 17H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Scan with your phone</h3>
      <p>Point your phone camera at this QR code to view your design in augmented reality</p>
    </template>
    <div v-else class="room-state"><i class="fal fa-image" /><p>Preparing your room preview.</p></div>
  </NewStudioModalsModalShell>
</template>

<script setup lang="ts">
import QRCodeVue from 'qrcode.vue'
defineProps<{ arPageUrl: string | null; modelUrl: string | null; loading: boolean; error: string | null; autoLaunch: boolean }>()
defineEmits<{ close: []; retry: [] }>()
onMounted(async () => {
  try { await import('@google/model-viewer') }
  catch (error) { console.error('Failed to load model-viewer:', error) }
})
</script>

<style scoped>
.qr { display: grid; width: 100%; min-height: 320.38px; margin-top: 17.95px; place-items: center; background: #efeee9; }
h3 { margin: 17.95px 0 0; text-align: center; font-size: 22px; display: flex; align-items: center; justify-content: center; gap: 8px; }
.phone-icon { display: inline-block; vertical-align: middle; }
p { margin: 17.95px 0 0; text-align: center; color: #1c1c1e; font-size: 16px; font-weight: 500; line-height: 22.617px; }
.room-state { display: grid; min-height: 260px; place-items: center; background: #e9e8e5; color: #777671; font-size: 30px; }
.room-state p { font-size: 14px; }
.room-state button { min-height: 44px; padding: 0 25px; border: 0; background: #2e3b48; color: #fff; font: inherit; font-weight: 700; }
.ar-launcher { position: absolute; width: 1px; height: 1px; overflow: hidden; opacity: 0; pointer-events: none; }
:global(.room-modal > h2) { margin-top: 17.95px; text-align: center; font-size: 34.105px; letter-spacing: -.341px; }
:global(.room-modal) { box-sizing: border-box; height: 585px; max-height: none !important; }
</style>
